<script>

    import { toast } from 'bulma-toast'
    import { accountStore, accountsStore, modalStore } from '../stores'

    import AccountsService from '../$services/accounts.service'

    import Form from '../$components/form.svelte'
    import Date from '../$components/date.svelte'
    import InputText from '../$components/input.text.svelte'
    import Select from '../$components/select.svelte'
    import ButtonSave from '../$components/button.save.svelte'
    import ButtonModal from '../$components/button.modal.svelte'
    import Switch from '../$components/switch.svelte'

    let data = {
        expired: $accountStore.expired,
        status: $accountStore.status,
        autoRenew: $accountStore.autoRenew,
    }

    let loading = false
    let updateExpired = false

    async function updateAccount() {

        loading = true
        const resp = await AccountsService.updateAccount($accountStore._id, data)
        loading = false

        if(!resp.success)
            return toast({message: resp.error.message, type: 'is-danger'})

        accountStore.set(resp.data)
        accountsStore.replace(resp.data)

        toast({message: 'Cuenta actualizada', type: 'is-success'})
        modalStore.set('account_modal')
    }

</script>

<Form on:submit={updateAccount} {loading}>
    
    <Select bind:value={data.status}
        label="Estatus de pago"
        options={[
            {value: 'pending', text: 'Pendiente'},
            {value: 'paid', text: 'Pagado'},
            {value: 'free', text: 'Gratis'},
        ]}
    />

    {#if data.status === 'paid' || data.status === 'free'}
        <Date bind:value={data.payment} label="Fecha de pago" />
    {/if}

    <div>
        <Switch bind:checked={data.autoRenew} label="Renovación automática" />
    </div>

    <div>
        <Switch bind:checked={updateExpired} label="Actualizar fecha de expiración" />
    </div>

    {#if updateExpired}
        <Date bind:value={data.expired} label="Fecha de expiración" />
    {/if}

    {#if data.status === 'paid' || data.status === 'free'}
        <InputText bind:value={data.reference} label="Referencia de pago" placeholder="Referencia de pago" required={data.status === 'paid'} />
    {/if}

    <div class="is-flex is-justify-content-flex-end is-align-items-center">
        <ButtonModal modalId="account_modal" text="Cancelar" icon="ban" />
        <ButtonSave icon="edit" text="Actualizar" />
    </div>
</Form>